<style scoped="scoped" lang="scss">
.inputClass /deep/ .el-input__inner {
  height: 28px !important;
}

.inputClass /deep/ .el-input__icon {
  //width: 25px !important;;
  line-height: 20px !important;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/warehouse/purchase/detail/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('caigoudingdanhao')">
            <el-input v-model="yt.conditions.purchaserOrderNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyingshangmingcheng')">
            <yi_cross_select multiple :component="'web_wms_purchase_receipt_supplier_information'" :ids.sync="yt.conditions.supplierIds"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('wuliaomingcheng')">
            <yi_cross_select multiple :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('mingxizhuangtai')">
            <yi_dictionary_select :disableIds="['0', '4']" :max="99" :multiple="true" :type="'WMS_PURCHASE_DETAIL_STATUS'" :ids.sync="yt.conditions.statusList"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ statusList: ['1', '2', '3', '5'] })">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-popconfirm v-if="utils.checkPower('web_warehouse_purchase_detail_receipt')" :title="$t('shifouquedingjieshou')" @confirm="accept">
          <el-button slot="reference" :disabled="selectedData.length == 0" size="mini" type="primary">
            {{ $t('jieshou') }}
          </el-button>
        </el-popconfirm>

        <el-button style="margin-left: 10px;" size="mini" :disabled="selectedData.length == 0" v-if="utils.checkPower('web_purchase_orderin_stock_batch_create')" @click="shengchengsonghuodan">
          {{ $t('shengchengsonghuodan') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" class="font-color-warning" v-if="utils.checkPower('web_warehouse_purchase_detail_cancel') && scope.row.status == 2" @click="yt.showEditDialog('quxiaojieshou', scope.row)">{{ $t('quxiaojieshou') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" v-if="utils.checkPower('web_warehouse_purchase_detail_refuse') && scope.row.status == 1" @click="yt.showEditDialog('jujuejieshou', scope.row)">{{ $t('jujuejieshou') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 生成送货单 -->

      <template v-if="yt.editObj.action == 'shengchengsonghuodan'">
        <!-- {{
          $nextTick(() => {
            $refs.yt2.list = addList;
          })
        }} -->
        <div class="dialog-scroller" style="display: flex;flex-direction: column;">
          <div>
            <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
              {{ $t('caigoudingdantouxinxi') }}
            </div>
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" style="width:800px">
              <el-form-item :label="$t('danjudalei')" required>
                <div style="width: 195px;">{{ $t('caigouruku') }}</div>
              </el-form-item>
              <el-form-item :label="$t('gongyingshangdizhi')" required>
                <el-input v-model="yt.editObj.supplierAddress" @input="$forceUpdate()"></el-input>
              </el-form-item>
              <el-form-item :label="$t('danjuxiaolei')" required>
                <el-select :clearable="true" v-model="yt.editObj.invoicesSmallValue" collapse-tags :placeholder="$t('qingxuanze')">
                  <el-option v-for="(category, index) in docCategories" :key="category.id" :label="category.smallName" :value="category.id"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('shouhuodizhi')" required>
                <el-input v-model="yt.editObj.address"></el-input>
              </el-form-item>
              <el-form-item :label="$t('gongyingshangmingcheng')" required>
                <yi_cross_select :max="1" :component="'web_wms_purchase_receipt_supplier_information'" :ids.sync="yt.editObj.supplierId" @getItems="getItemSupplier"></yi_cross_select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{ $t('caigoudingdanmingxixinxi') }}
          </div>
          <div style="flex:1;">
            <yi_curd_table :name="$options.name + '2'" ref="yt2" :columns="columnsItem" :isRandKey="false">
              <!-- 左侧按钮插槽 -->
              <template #buttonsL="scope">
                <el-button size="mini" @click="addTable(scope._index, $event)" type="primary">
                  {{ $t('xinzeng') }}
                </el-button>
                <!--                <el-button size="mini" @click="isShowUploadDialog=true" plain>-->
                <!--                  {{$t('daoru')}}-->
                <!--                </el-button>-->
              </template>

              <template #caigoudingdanhao="scope">
                <yi_cross_select
                  :disabled="yt.editObj.supplierId == null"
                  class="inputClass"
                  :max="1"
                  :component="'web_supplier_portal_purchase_order_accept_list'"
                  :ids.sync="scope.row.id"
                  :fixConditions="{ deliveryQuantityResidueNotZero: true, supplierIds: yt.editObj.supplierId }"
                  @getItems="
                    item => {
                      getOrder(scope._index, item);
                    }
                  "
                >
                </yi_cross_select>
              </template>
              <template #mingxizhuangtai="scope">
                <el-tag size="small" :value="scope.row.status">{{ $t('xinjian') }}</el-tag>
              </template>
              <template #wuliaobianmamingcheng="scope">
                {{ scope.row.order.material && scope.row.order.material.code }}/{{ scope.row.order.material && scope.row.order.material.name }}
              </template>

              <template #shengchanriqi="scope">
                <yi_time_input class="inputClass" :format="'yyyy-MM-dd'" type="date" :time.sync="scope.row.productionDate"> </yi_time_input>
              </template>
              <template #shixiaoriqi="scope">
                <yi_time_input class="inputClass" :format="'yyyy-MM-dd'" type="date" :time.sync="scope.row.loseDate"> </yi_time_input>
              </template>
              <template #bencisonghuoshuliang="scope">
                <el-input-number class="inputClass" :precision="0" :min="0" v-model="scope.row.deliveryQuantity" :controls="false"></el-input-number>
              </template>

              <template #caozuo="scope">
                <el-row :gutter="10">
                  <el-col :span="0.1">
                    <el-button type="text" class="font-color-danger" @click="remove(scope._index, $event)">
                      {{ $t('shanchu') }}
                    </el-button>
                  </el-col>
                </el-row>
              </template>
            </yi_curd_table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="save()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <!-- 拒绝接收 -->
      <template v-if="yt.editObj.action == 'jujuejieshou'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('jushouyuanyin')" required>
            <el-input type="textarea" v-model="yt.editObj.refuseCause"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/warehouse/purchase/detail/refuse')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 取消接收 -->
      <template v-if="yt.editObj.action == 'quxiaojieshou'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('quxiaoyuanyin')" required>
            <el-input type="textarea" v-model="yt.editObj.cancelCause"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/warehouse/purchase/detail/cancel')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_supplier_portal_purchase_order_accept_list',
  data() {
    return {
      idList: [],
      selectedData: [],
      columns: [
        {
          label: 'xuanze',
          type: 'selection',
          align: 'center'
        },
        {
          label: 'caigoudingdanhao',
          prop: 'purchaserOrder.no'
        },
        {
          label: 'caigoudingdanhanghao',
          prop: 'no'
        },
        {
          label: 'mingxizhuangtai',
          prop: 'status',
          type: 'dictionary_tag',
          key: 'WMS_PURCHASE_DETAIL_STATUS'
        },
        {
          label: 'wuliaobianma',
          prop: 'material.code'
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name',
          width: 230
        },
        {
          label: 'dingdanshuliang',
          prop: 'quantity',
          width: 130
        },
        {
          label: 'leijisonghuoshuliang',
          prop: 'deliveryQuantitySum',
          width: 130
        },
        {
          label: 'daisonghuoshuliang',
          prop: 'deliveryQuantityResidue',
          width: 130
        },
        {
          label: 'caigoudanwei',
          prop: 'unit',
          width: 130
        },
        {
          label: 'dingdanjiaoqi',
          prop: 'deliveryTime',
          type: 'time',
          width: 130
        },

        {
          label: 'fahuoriqi',
          prop: 'sendDeliveryTime',
          type: 'time',
          format: 'YYYY-MM-DD'
        },
        {
          label: 'jieshoushijian',
          prop: 'receiptTime',
          type: 'time'
        },
        {
          label: 'jushouyuanyin',
          prop: 'refuseCause'
        },
        {
          label: 'jushoushijian',
          prop: 'refuseTime',
          type: 'time'
        },
        {
          label: 'gongyingshangmingcheng',
          prop: 'supplierName'
        },
        {
          label: 'caigouyuan',
          prop: 'purchaserName'
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 'auto'
        },
        {
          label: 'caozuo',
          fixed: 'right',
          type: 'slot',
          width: 130
        }
      ],
      docCategories: [],
      columnsItem: [
        // {
        //   label: "rukudingdanhanghao",
        //   type: "index",
        //   isStar: true,
        // },
        {
          label: 'caigoudingdanhao',
          type: 'slot',
          wrap: true,
          width: 130
        },
        {
          label: 'caigoudingdanhanghao',
          prop: 'order.no',
          isStar: true
        },
        {
          label: 'wuliaobianmamingcheng',
          type: 'slot',
          width: 130
        },
        {
          label: 'dingdanshuliang',
          prop: 'order.quantity',
          width: 130
        },
        {
          label: 'leijisonghuoshuliang',
          prop: 'order.deliveryQuantitySum',
          width: 130
        },
        {
          label: 'daisonghuoshuliang',
          prop: 'order.deliveryQuantityResidue',
          width: 130
        },

        {
          label: 'caigoudanwei',
          prop: 'order.unit'
        },
        {
          label: 'bencisonghuoshuliang',
          width: 150,
          type: 'slot'
        },
        // {
        //   label: "shishoushuliang",
        //   prop: "defaultUnit",
        //   wrap: true,
        // },
        // {
        //   label: "shifoupiciguanli",
        //   prop: "defaultUnit",
        //   wrap: true,
        // },
        {
          label: 'shengchanriqi',
          type: 'slot'
        },
        {
          label: 'shixiaoriqi',
          type: 'slot'
        },
        {
          label: 'shouhuoriqi',
          prop: 'order.sendDeliveryTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 100,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    this.getDocumentList();
    setTimeout(() => {
      if(this.yt.name==='web_supplier_portal_purchase_order_accept_list'){
        this.yt.conditions.statusList = ['1', '2', '3', '5'];
      }
      this.yt.SELECT_URL = '/web/warehouse/purchase/detail/extend/listByIds';
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'purchaserOrder.no';
      this.yt.get(1);
    }, 300);
  },
  methods: {
    getDocumentList() {
      this.http
        .get('/web/document/permission/configuration/item/list?type=0&categories=0')
        .then(res => {
          this.docCategories = res.data;
        })
        .catch(error => {
          this.utils.errorMessage(this.$t(error));
        });
    },

    shengchengsonghuodan() {
      if (this.selectedData.length == 0) {
        this.utils.errorMessage(this.$t('qingxuanzejilu'));
        return;
      }

      for (let index = 0; index < this.selectedData.length; index++) {
        const element = this.selectedData[index];

        if (index > 0) {
          if (this.selectedData[index].purchaserOrder.supplierId != this.selectedData[index - 1].purchaserOrder.supplierId) {
            this.utils.errorMessage(this.$t('qingxuanzetongyigongyingshang'));
            return;
          }
        }

        if (element.status != '2' && element.status != '5') {
          this.utils.errorMessage(this.$t('qingxuanzeyijieshouhuozhesonghuozhongjilu'));
          return;
        }

        if (element.deliveryQuantityResidue == 0) {
          this.utils.errorMessage(this.$t('qingxuanzedaisonghuoshuliangbuweilingdejilu'));
          return;
        }
      }
      console.log(22222);

      this.yt.showEditDialog('shengchengsonghuodan', null, '80%');
      this.setDefaultValue();

      setTimeout(() => {
        for (let index = 0; index < this.selectedData.length; index++) {
          const element = this.selectedData[index];
          const newItem = {
            id: element.id,
            rowNum: '',
            deliveryQuantity: 0,
            purchaserOrderId: element.purchaserOrderId,
            quantity: 0,
            productionDate: null,
            loseDate: null,
            order: this.utils.copy(element)
          };
          this.$refs.yt2.list.push(newItem);
          console.log(this.$refs.yt2.list);
        }
      }, 300);

      console.log(this.selectedData);
      return;
    },

    setDefaultValue() {
      if (this.selectedData.length > 0) {
        this.yt.editObj.supplierId = this.selectedData[0].purchaserOrder.supplierId;
        this.yt.editObj.supplierAddress = this.selectedData[0].purchaserOrder.supplierAddress;
      }
    },
    getOrder(index, item) {
      this.$refs.yt2.list[index].order = this.utils.copy(item);

      // Object.keys(item).forEach((key) => {
      //   this.$set(this.$refs.yt2.list[index], key, this.utils.copy(item)[key]);
      // });

      console.log(this.$refs.yt2.list[index]);
    },
    addTable(rows) {
      if (this.yt.editObj.supplierId == null || this.yt.editObj.supplierId == '') {
        this.utils.errorMessage(this.$t('qingxuanzegongyingshang'));
        return;
      }

      const newItem = {
        rowNum: '',
        deliveryQuantity: 0,
        purchaserOrderId: null,
        quantity: 0,
        productionDate: null,
        loseDate: null,
        order: {}
      };
      this.$refs.yt2.list.push(newItem);
    },
    remove(index, item) {
      console.log(item);
      this.$refs.yt2.list.splice(index, 1);
    },
    selectionChange(rows) {
      this.selectedData = rows;
    },

    //保存
    save() {
      if (this.$refs.yt2.list.length == 0) {
        this.utils.errorMessage(this.$t('meiyoumingxi'));
        return;
      }

      if (this.yt.editObj.supplierId == null) {
        this.utils.errorMessage(this.$t('qingtianxiebitianshuju'));
        return;
      }
      if (this.yt.editObj.supplierAddress == null) {
        this.utils.errorMessage(this.$t('qingtianxiebitianshuju'));
        return;
      }
      if (this.yt.editObj.address == null) {
        this.utils.errorMessage(this.$t('qingtianxiebitianshuju'));
        return;
      }
      if (this.yt.editObj.invoicesSmallValue == null) {
        this.utils.errorMessage(this.$t('qingtianxiebitianshuju'));
        return;
      }

      let params = [];
      for (let index = 0; index < this.$refs.yt2.list.length; index++) {
        const item = this.$refs.yt2.list[index];
        if (item.id == null) {
          this.utils.errorMessage(this.$t('qingxuanzecaigoudingdan'));
          return;
        }

        params.push({
          id: item.id,
          supplierId: this.yt.editObj.supplierId,
          supplierAddress: this.yt.editObj.supplierAddress,
          invoicesSmallValue: this.yt.editObj.invoicesSmallValue,
          address: this.yt.editObj.address,
          remark: this.yt.editObj.remark,
          purchaserOrderId: item.order.purchaserOrderId,
          deliveryQuantity: item.deliveryQuantity,
          rowNum: index + 1,
          productionDate: item.productionDate,
          loseDate: item.loseDate
        });
      }
      this.http
        .post('/web/purchase/order/in/stock/batch/create', params)
        .then(res => {
          this.yt.isShowEditDialog = false;
          this.utils.successMessage(this.$t(res.msg));
          this.selectedData = [];

          this.yt.get();
        })
        .catch(error => {
          this.utils.errorMessage(this.$t(error));
        });
    },
    getItemSupplier(item) {
      this.yt.editObj.supplierAddress = item.address;
    },
    //接收
    accept() {
      // 构建一个包含对象 ID 的数组
      let idsArray = this.selectedData.map(item => item);
      // 发送 POST 请求给后端
      this.http
        .post('/web/warehouse/purchase/detail/receipt', idsArray)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get();
          this.selectedData = [];
        })
        .catch(error => {
          this.utils.errorMessage(this.$t(error));
        });
    },

    //拒绝接收
    refuse() {
      // 构建一个包含对象 ID 的数组
      let idsArray = this.selectedData.map(item => item.id);
      // 发送 POST 请求给后端
      this.http
        .post('/web/warehouse/purchase/detail/refuse', idsArray)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(error => {
          this.utils.errorMessage(this.$t(error));
        });
    }
  }
};
</script>
